import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import LogisticReportTimeRangeForm from "./LogisticReportTimeRangeForms/LogisticReportTimeRangeForm";
import LogisticReportViewPanelControl from "./LogisticReportViewPanelControl";
import LogisticReportsControlPoints from "./LogisticReportsControlPoints";
import LogisticReportsTaskTrips from "./LogisticReportsTaskTrips";
import LogisticReportsTaskTrip from "./LogisticReportsTaskTrip";
import { withAuth } from "../../../shared/containers/containerAuth";

const viewPanelItems = {
  controPointReports: "controPointReports",
  taskTripReports: "taskTripReports",
  taskTripReport: "taskTripReport",
};

class LogisticReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewPanel: viewPanelItems.controPointReports,
    };
  }

  onSetViewPanel(viewPanel) {
    this.setState({ viewPanel });
  }

  componentDidMount() {
    const taskTripId = window.location.pathname.replace("/logistic/reports", "").replace("/", "");
    if (taskTripId !== "" && taskTripId !== "/") {
      this.setState({ viewPanel: viewPanelItems.taskTripReport });
    }
  }

  render() {
    const { data } = this.props;
    const { viewPanel } = this.state;
    const setViewPanel = this.onSetViewPanel.bind(this);

    const cpPermission = data.permissions.includes(26005);
    const taskTripsPermission = data.permissions.includes(53001);
    const taskTripPermission = data.permissions.includes(53002);

    return (
      <div className={styles.logisticReportMainContainer}>
        {viewPanel !== viewPanelItems.taskTripReport ? (
          <div>
            <LogisticReportTimeRangeForm viewPanel={viewPanel} viewPanelItems={viewPanelItems} />
            <LogisticReportViewPanelControl viewPanel={viewPanel} viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} />
          </div>
        ) : null}

        {viewPanel === viewPanelItems.controPointReports && cpPermission ? (
          <LogisticReportsControlPoints onSetViewPanel={setViewPanel} />
        ) : null}
       
        {viewPanel === viewPanelItems.taskTripReports && taskTripsPermission ? (
          <LogisticReportsTaskTrips onSetViewPanel={setViewPanel} />
        ) : null}
       
        {viewPanel === viewPanelItems.taskTripReport && taskTripPermission ? (
          <LogisticReportsTaskTrip onSetViewPanel={setViewPanel} viewPanelItems={viewPanelItems} />
        ) : null}
      </div>
    );
  }
}

export default withAuth(React.memo(LogisticReports));
